<script setup>
    import { useRequestsStore } from '@/stores/storeRequests';  
    import { useSettingsStore } from '@/stores/storeSettings';

    const storeRequests = useRequestsStore();
    const storeSettings = useSettingsStore();

    const props = defineProps({
        title: {
            type: String,
            default: 'Обменять'
        },
        icon: {
            type: Boolean,
            default: false
        }
    })

</script>
<template>
    <button v-if="storeRequests.isAuthenticated && storeSettings.statusStockActive" class="btn">
        <svg v-if="props.icon" width="24" height="24" class="leaf --green"><use href="#leaf"></use></svg>
        <slot>Обменять</slot>
    </button>
</template>
<style lang='scss' scoped>
@use '@/assets/scss/base/vars';
</style>